import { SharedWorld, WorldAdventure, WorldPin } from '../models/store-rail.model';

const pin = (
  id: string,
  name: string,
  top: string,
  left: string,
  adventure: WorldAdventure,
  featured = false,
): WorldPin => ({ id, name, top, left, adventure, featured });

export const SHARED_WORLDS: SharedWorld[] = [
  {
    key: 'ashmorrow',
    name: 'Ashmorrow',
    image: 'assets/images/Ashmorrow.jpeg',
    gamesystem: 'D&D 5e',
    genre: 'fantasy',
    pinsPlaced: 4182,
    contributors: 912,
    gamesRunning: 37,
    pitch: 'A drowned duchy of lantern-lit quays, flooded chapels, and inns that still take coin after midnight.',
    pins: [
      pin('ash-moonwharf', 'The Moonwharf', '20%', '70%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: 'Moonwharf Market',
        author: 'Halloran',
        region: 'Moonwharf Quay',
        rating: '4.9',
        reviews: '302 reviews',
        desc: 'Stalls, pickpockets, and a stall that sells maps of places that do not exist yet.',
        playtime: '2 hrs',
        party: 'Lvl 1–4 · 1–4',
        price: '$5',
        image: 'assets/images/Moonwharf.jpg',
      }),
      pin('ash-blackwater', 'Blackwater Inn', '32%', '64%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: 'Blackwater Inn',
        author: 'Torvild Ash',
        region: 'Blackwater Reach',
        rating: '4.5',
        reviews: '91 reviews',
        desc: 'A guild inn that still floods on the spring tide. Contracts are signed anyway, upstairs, by lantern.',
        playtime: '3 hrs',
        party: 'Lvl 2–4 · 2–5',
        price: '$6',
        image: 'assets/images/blackwater.jpg',
      }),
      pin('ash-apothecary', 'Apothecary of Ash', '45%', '68%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: 'Apothecary of Ash',
        author: 'Sella Wren',
        region: 'Ashmarket',
        rating: '4.8',
        reviews: '176 reviews',
        desc: 'Remedies, poisons, and a debt the owner will not name. The bell over the door does not match the one outside.',
        playtime: '2 hrs',
        party: 'Lvl 1–3 · 1–4',
        price: '$4',
        image: 'assets/images/apothecary.jpg',
      }),
      pin('ash-drowned-bell', 'The Drowned Bell', '60%', '64%', {
        type: 'Adventure',
        storeStatus: 'In store',
        name: 'The Drowned Bell',
        author: 'Halloran',
        region: 'Duchy of Nalmara',
        rating: '4.9',
        reviews: '302 reviews',
        desc: 'A flooded chapel rings on the hour and nobody will say why. Three-act delve with a hard choice at the bottom.',
        playtime: '6 hrs',
        party: 'Lvl 4–6 · 4–5',
        price: '$9',
        image: 'assets/images/Ashmorrow.jpeg',
      }, true),
      pin('ash-orberia-ruins', 'Ruins of Orberia', '72%', '68%', {
        type: 'Adventure',
        storeStatus: 'In store',
        name: 'Ruins of Orberia',
        author: 'Vessa Corr',
        region: 'The Saltward Stones',
        rating: '4.6',
        reviews: '128 reviews',
        desc: 'A fallen spire from another duchy, dragged here by the tide. Something in the cellars still answers to Orin.',
        playtime: '5 hrs',
        party: 'Lvl 3–5 · 3–5',
        price: '$8',
        image: 'assets/images/Orberia.jpeg',
      }),
    ],
  },
  {
    key: 'orberia',
    name: 'Orberia',
    image: 'assets/images/Orberia.jpeg',
    gamesystem: 'Pathfinder 2e',
    genre: 'fantasy',
    pinsPlaced: 1640,
    contributors: 388,
    gamesRunning: 14,
    pitch: 'Old royal roads, sunken barges, and barracks that still drill for a war that ended a generation ago.',
    pins: [
      pin('orb-gilded-sept', 'The Gilded Sept', '22%', '64%', {
        type: 'Side Quest',
        storeStatus: 'In store',
        name: 'Gilded Sept Reliquary',
        author: 'Vessa Corr',
        region: 'Sept of Orin',
        rating: '4.0',
        reviews: '19 reviews',
        desc: 'A relic walked out of vespers. Bring it back before the bells, and do not look it in the face.',
        playtime: '2 hrs',
        party: 'Lvl 2–4 · 3–5',
        price: 'Free',
      }),
      pin('orb-emberfall', 'Emberfall Barracks', '34%', '70%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: 'Emberfall Barracks',
        author: 'Daybreak Collective',
        region: 'Emberfall Road',
        rating: '4.2',
        reviews: '38 reviews',
        desc: 'Drill sergeants, bunks, and a missing roster. The war is over; the night watch is not.',
        playtime: '2 hrs',
        party: 'Lvl 1–3 · 1–4',
        price: 'Free',
      }),
      pin('orb-cartographer', "The Cartographer's Rest", '48%', '58%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: "The Cartographer's Rest",
        author: 'Daybreak Collective',
        region: 'Old Royal Mile',
        rating: '4.6',
        reviews: '80 reviews',
        desc: 'Maps, tea, and a back room where blank vellum is never blank for long.',
        playtime: '2 hrs',
        party: 'Lvl 1–5 · 1–4',
        price: '$4',
      }),
      pin('orb-hollowmere', 'Hollowmere Docks', '62%', '64%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: 'Hollowmere Docks',
        author: 'Vessa Corr',
        region: 'Hollowmere',
        rating: '4.3',
        reviews: '44 reviews',
        desc: 'Warehouses, night ferries, and a clerk who sells berth numbers twice.',
        playtime: '2 hrs',
        party: 'Lvl 1–4 · 1–4',
        price: '$3',
      }),
      pin('orb-vaults', 'Vaults of Sar Orin', '76%', '66%', {
        type: 'Adventure',
        storeStatus: 'In store',
        name: 'Vaults of Sar Orin',
        author: 'Vessa Corr',
        region: 'The Reach of Orin',
        rating: '4.6',
        reviews: '120 reviews',
        desc: 'The royal vaults were sealed wet. They are not empty. One night aboard the barge before it goes under again.',
        playtime: '8 hrs',
        party: 'Lvl 3–6 · 3–6',
        price: '$10',
      }, true),
    ],
  },
  {
    key: 'bluendia',
    name: 'Bluendia',
    image: 'assets/images/Bluendia.jpeg',
    gamesystem: 'D&D 5e',
    genre: 'fantasy',
    pinsPlaced: 2205,
    contributors: 511,
    gamesRunning: 22,
    pitch: 'Shelf-cities of glass and tide. Academies still teach below the waterline; the students want out.',
    pins: [
      pin('blu-tideglass', 'Tideglass Academy', '20%', '64%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: 'Tideglass Academy',
        author: 'Marek Sail',
        region: 'Bluendia Shelf',
        rating: '4.7',
        reviews: '154 reviews',
        desc: 'A drowned school still takes pupils. Tuition is a secret, and the students have offered you a trade.',
        playtime: '3 hrs',
        party: 'Lvl 2–4 · 2–4',
        price: '$7',
      }, true),
      pin('blu-coral', 'The Coral Vigil', '36%', '70%', {
        type: 'One Shot Encounter',
        storeStatus: 'In store',
        name: 'The Coral Vigil',
        author: 'Marek Sail',
        region: 'The Living Shelf',
        rating: '4.2',
        reviews: '28 reviews',
        desc: 'Stand a watch on living coral. The reef remembers who failed last time.',
        playtime: '2 hrs',
        party: 'Lvl 4–6 · 3–5',
        price: '$5',
      }),
      pin('blu-gallows', 'Saltmarsh Gallows', '50%', '64%', {
        type: 'Adventure',
        storeStatus: 'In store',
        name: 'Saltmarsh Gallows',
        author: 'Marek Sail',
        region: 'Saltmarsh Ward',
        rating: '4.4',
        reviews: '67 reviews',
        desc: 'The tide takes the condemned. Tonight it brought one back, and the marshal wants a quiet table.',
        playtime: '4 hrs',
        party: 'Lvl 3–5 · 3–5',
        price: '$7',
      }),
      pin('blu-wyrmspume', 'Wyrmspume Lighthouse', '64%', '78%', {
        type: 'Adventure',
        storeStatus: 'In store',
        name: 'Wyrmspume Lighthouse',
        author: 'Marek Sail',
        region: 'The Spume',
        rating: '4.5',
        reviews: '73 reviews',
        desc: 'The lamp is lit for ships that should not arrive. Climb it before the next bell.',
        playtime: '5 hrs',
        party: 'Lvl 3–5 · 3–5',
        price: '$8',
      }),
      pin('blu-pearl', 'The Pearl Exchange', '76%', '60%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: 'The Pearl Exchange',
        author: 'Sella Wren',
        region: 'Tideglass Market',
        rating: '4.6',
        reviews: '112 reviews',
        desc: 'Pearls, debts, and a vault that opens only at slack water. Bring a ledger or a lie.',
        playtime: '2 hrs',
        party: 'Lvl 1–4 · 1–4',
        price: '$5',
      }),
    ],
  },
  {
    key: 'vrokan-waste',
    name: 'Vrokan Waste',
    image: 'assets/images/poster-map.png',
    gamesystem: 'Pathfinder 2e',
    genre: 'fantasy',
    pinsPlaced: 610,
    contributors: 147,
    gamesRunning: 6,
    pitch: 'Dry riverbeds, rust wells, and caravans that pay in water. Something walks the salt at night.',
    pins: [
      pin('vrok-bazaar', 'The Ash Bazaar', '24%', '56%', {
        type: 'One Shot Encounter',
        storeStatus: 'In store',
        name: 'Ash Bazaar Heist',
        author: 'Odai Vrok',
        region: 'The Ash Bazaar',
        rating: '4.3',
        reviews: '52 reviews',
        desc: 'Steal the water-token before the bazaar closes. Ninety minutes, no mercy.',
        playtime: '2 hrs',
        party: 'Lvl 3–5 · 3–4',
        price: 'Free',
      }, true),
      pin('vrok-wells', 'Rustwater Wells', '40%', '66%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: 'Rustwater Wells',
        author: 'Odai Vrok',
        region: 'The Wells',
        rating: '4.1',
        reviews: '31 reviews',
        desc: 'The last clean draw for a day in any direction. The well-keeper sells sips, secrets, and second chances.',
        playtime: '2 hrs',
        party: 'Lvl 1–3 · 1–4',
        price: '$3',
      }),
      pin('vrok-bonepicker', "The Bonepicker's Camp", '54%', '56%', {
        type: 'Establishment',
        storeStatus: 'In store',
        name: "The Bonepicker's Camp",
        author: 'Odai Vrok',
        region: 'Dry Riverbed',
        rating: '4.0',
        reviews: '24 reviews',
        desc: 'Salvage tents on the old river. They buy what the salt does not keep, and they always know who passed at dusk.',
        playtime: '2 hrs',
        party: 'Lvl 1–4 · 1–5',
        price: '$4',
      }),
      pin('vrok-kiln', 'Kiln of the Vrok', '68%', '74%', {
        type: 'Adventure',
        storeStatus: 'In store',
        name: 'Kiln of the Vrok',
        author: 'Odai Vrok',
        region: 'The Kiln Flats',
        rating: '4.5',
        reviews: '61 reviews',
        desc: 'Glass and iron fired in a dry river. The kiln still runs, and the thing that tends it does not sleep.',
        playtime: '5 hrs',
        party: 'Lvl 3–5 · 3–5',
        price: '$8',
      }),
      pin('vrok-halberd', 'Broken Halberd Outpost', '80%', '56%', {
        type: 'Campaign',
        storeStatus: 'In store',
        name: 'Broken Halberd Outpost',
        author: 'Odai Vrok',
        region: 'The Vrokan Waste',
        rating: '4.1',
        reviews: '22 reviews',
        desc: 'Hold a fort that was never meant to last the dry season. Water is currency. The caravan is late.',
        playtime: '10 hrs',
        party: 'Lvl 4–6 · 4–6',
        price: '$12',
      }),
    ],
  },
];

export function featuredPin(world: SharedWorld): WorldPin {
  return world.pins.find((p) => p.featured) ?? world.pins[0];
}
